import React from 'react'
import Logo from "../../../../assets/images/LogoNew.svg";
import { getBrokerProfile } from "../../../Broker/BrokerService";
import { ApplicantHeaderActions } from '../../../../components/ApplicationInvite';
import { FORM_AUTOFILL_PROPS } from '../../../../components/InputField/autofillProps';
import LogoutWithReason from '../../../../components/LogoutWithReason/LogoutWithReason';
import { Form } from 'react-bootstrap';
import { useTranslation } from '../../../../store/context/TranslationContext';
import { FaSpinner } from 'react-icons/fa';
import PlanSwitchButton from './components/PlanSwitchButton';

export const FORM_CONTAINER_TYPE = {
    EDD: "EDD"
}
const FormContainerV2 = ({
    asLabel,
    editMode,
    form_id,
    title = '',
    children,
    isLoading,
    formContainerType,
    // Plan switch props
    showTypeSwitch,
    currentType,
    onSwitchType,
    typeSwitchDisabled,
    typeSwitchLoading,
    applicationForm,
    applicationFormId,
    formData,
    onApplicationFormUpdated,
    hideLogout = false,
    // Hide the header FV Bank logo when the caller renders its own FV Bank brand (e.g.
    // the broker co-branding strip), so it doesn't appear twice.
    hideLogo = false,
}) => {
    const { t } = useTranslation();
    const isEddApplication = formContainerType === FORM_CONTAINER_TYPE.EDD
        && applicationForm?.eDDApplication === true;

    // Broker admins fill the form on behalf of their client; the form header logo
    // is not shown for broker sessions (they already see the broker brand in the
    // portal chrome). Regular applicants still see the FV Bank logo.
    const isBrokerSession = getBrokerProfile()?.role === "broker_admin";

    return (
        <div className={!asLabel && !editMode ? 'form-content-container xl' : ""}>
            <div className='form-content-header form-content-header--v2'>
                {!asLabel && !isBrokerSession && !hideLogo ? (
                    <img
                        src={Logo}
                        alt={t("fv-bank")}
                        className="logo logo-dark form-content-logo"
                    />
                ) : null}

                <div className='form-content-header__actions'>
                    {showTypeSwitch && (
                        <PlanSwitchButton
                            currentType={currentType}
                            disabled={typeSwitchDisabled}
                            loading={typeSwitchLoading}
                            onSwitchType={onSwitchType}
                        />
                    )}
                    <ApplicantHeaderActions
                        applicationForm={applicationForm}
                        formData={formData}
                        formId={applicationFormId || applicationForm?._id || form_id}
                        formType={applicationForm?.formType}
                        onApplicationFormUpdated={onApplicationFormUpdated}
                        invitePersistence={isEddApplication ? "edd-request" : "application-form"}
                        disabled={asLabel || editMode}
                        logoutComponent={hideLogout ? null : (
                            <LogoutWithReason
                                form_id={form_id}
                                withoutReason={isEddApplication}
                            />
                        )}
                    />
                </div>
            </div>

            {
                isLoading ? (
                    <div className=" form-content-body  d-flex justify-content-center align-items-center flex-1">
                        <FaSpinner size={20} className="spinner" />
                    </div>
                ) : (
                    <Form className={asLabel ? "" : 'form-content-body d-flex flex-column'} noValidate {...FORM_AUTOFILL_PROPS}>
                        <div className='form-content-body-header'>
                            <div className="heading">{t(title)}</div>
                        </div>

                        {children}
                    </Form>
                )
            }
        </div>
    )
}

export default FormContainerV2;
